export const GET_NOTIFICATIONS = "GET_NOTIFICATIONS";
export const GET_NOTIFICATIONS_SUCCESS = "GET_NOTIFICATIONS_SUCCESS";
export const GET_NOTIFICATIONS_FAILED = "GET_NOTIFICATIONS_FAILED";

export const SAVE_DEVICE_TOKEN = "SAVE_DEVICE_TOKEN";
export const SAVE_DEVICE_TOKEN_SUCCESS = "SAVE_DEVICE_TOKEN_SUCCESS";
export const SAVE_DEVICE_TOKEN_FAILED = "SAVE_DEVICE_TOKEN_FAILED";

export const UPDATE_NOTIFCATION_STATUS = "UPDATE_NOTIFCATION_STATUS";
export const UPDATE_NOTIFCATION_STATUS_SUCCESS = "UPDATE_NOTIFCATION_STATUS_SUCCESS";
export const UPDATE_NOTIFCATION_STATUS_FAILED = "UPDATE_NOTIFCATION_STATUS_FAILED";

export const CLEAR_ALL_NOTIFICATIONS = "CLEAR_ALL_NOTIFICATIONS";
export const CLEAR_ALL_NOTIFICATIONS_SUCCESS = "CLEAR_ALL_NOTIFICATIONS_SUCCESS";
export const CLEAR_ALL_NOTIFICATIONS_FAILED = "CLEAR_ALL_NOTIFICATIONS_FAILED";
